import { type UploadFile, setProvidedApiClient } from '@pba/media-chunked-upload';
import { createContext } from 'react';
import { mediaModuleClient } from 'common/services';

export type { UploadFile, UploadSubscriber } from '@pba/media-chunked-upload';

export type ContentType = 'content_object';
export type UploadContextType = Partial<
  Record<ContentType, Partial<Record<string, Partial<Record<VideoType, UploadFile>>>>>
>;
export type UploadSuccessAction = ({ id, ref }: { id: string; ref: string }) => void;
export type VideoType = 'full' | 'trailer';

export const UploadContext = createContext<{
  removeUpload: (params: { contentType: ContentType; ref: string; videoType: VideoType }) => void;
  setUpload: ({
    contentType,
    file,
    onSuccessAction,
    ref,
    videoType,
  }: {
    contentType: ContentType;
    file: File;
    onSuccessAction: UploadSuccessAction;
    ref: string;
    videoType: VideoType;
  }) => void;
  uploads: UploadContextType;
} | null>(null);

setProvidedApiClient({ axiosInstance: mediaModuleClient });
